export const tableOption = {
    align: 'center',
    menuAlign: 'center',
    border: true,
    stripe: true,
    columnBtn: false,
    refreshBtn: false,
    saveBtn: false,
    updateBtn: false,
    cancelBtn: false,
    addBtn: false,
    delBtn: false,
    editBtn: false,
    selection: true,
    selectClearBtn: false,
    column: [
      {
        label: '标签名称',
        prop: 'tagName',
        placeholder: '请输入标签名称',
        rules: [{
          required: true,
          message: "标签名称不能为空",
          trigger: "blur"
        },{
          max: 32,
          message: '标签名称长度不能超过32',
          trigger: 'blur'
          },
        ]
      },
      {
        label: '标签分组',
        prop: 'groupId',
        formsolt: true,
        solt: true,
        hide: true,
        rules: [{
          required: true,
          message: "标签分组不能为空",
          trigger: "blur"
        }]
      },
      {
        label: '标签分组名称',
        prop: 'groupName',
        formsolt: true,
        solt: true,
        hide: true,
        editVisdiplay: false,
        addVisdiplay: false,
      },
      {
        label: '创建人',
        prop: 'creator',
        editVisdiplay: false,
        addVisdiplay: false,
      },
      {
        label: '上传时间',
        prop: 'insertedTime',
        sortable: true,
        editVisdiplay: false,
        addVisdiplay: false,
      }
    ]
  }